module.exports = __webpack_public_path__ + "img/23_61.a495028c.png";